const routes = [

    // Transactions

    {
        path : '/admin',
        component : () => import('../components/dashboard/dashboard'),
        meta : {
            requiresAuth : true
        }
    },
    // old Transactions

    {
        path : '/admin/old_dashboard',
        component : () => import('../components/dashboard/old_dashboard.vue'),
        meta : {
            requiresAuth : true
        }
    },

    //Profile

    {
        path : '/admin/settings',
        component : () => import('../components/settings/open'),
        meta : {
            requiresAuth : true,
        },
        children : [
            {
                path : '/admin/settings',
                component : () => import('../components/settings/profile'),
            },
            {
                path : '/admin/password',
                component : () => import('../components/settings/password'),
            },
        ]
    },

    // Transactions

    {
        path : '/admin/transactions',
        component : () => import('../components/transactions/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/transactions/:id/view',
        component : () => import('../components/transactions/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/transactions/:id/view',
                component : () => import('../components/transactions/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/transactions/:id/accounting',
                component : () => import('../components/transactions/accounting'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/transactions/:id/timeline',
                component : () => import('../components/transactions/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Zesa

    {
        path : '/admin/zesa',
        component : () => import('../components/zesa/index'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/zesa/create',
        component : () => import('../components/zesa/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/zesa/:id/view',
        component : () => import('../components/zesa/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/zesa/:id/view',
                component : () => import('../components/zesa/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/zesa/:id/timeline',
                component : () => import('../components/zesa/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // gift-card-purchase

    {
        path : '/admin/gift-card-purchase',
        component : () => import('../components/gift-card-purchase/index'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/gift-card-purchase/create',
        component : () => import('../components/gift-card-purchase/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/gift-card-purchase/:id/view',
        component : () => import('../components/gift-card-purchase/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/gift-card-purchase/:id/view',
                component : () => import('../components/gift-card-purchase/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/gift-card-purchase/:id/timeline',
                component : () => import('../components/gift-card-purchase/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // ticket-purchase

    {
        path : '/admin/ticket-purchase',
        component : () => import('../components/ticket-purchase/index'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/ticket-purchase/create',
        component : () => import('../components/ticket-purchase/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/ticket-purchase/:id/view',
        component : () => import('../components/ticket-purchase/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/ticket-purchase/:id/view',
                component : () => import('../components/ticket-purchase/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/ticket-purchase/:id/timeline',
                component : () => import('../components/ticket-purchase/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Biller-payment

    {
        path : '/admin/biller-payment',
        component : () => import('../components/billers/biller-payment/index'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/biller-payment/create',
        component : () => import('../components/billers/biller-payment/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/biller-payment/:id/view',
        component : () => import('../components/billers/biller-payment/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/biller-payment/:id/view',
                component : () => import('../components/billers/biller-payment/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/biller-payment/:id/timeline',
                component : () => import('../components/billers/biller-payment/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },


    // Airtime

    {
        path : '/admin/airtime',
        component : () => import('../components/airtime/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/airtime/create',
        component : () => import('../components/airtime/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/airtime/:id/view',
        component : () => import('../components/airtime/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/airtime/:id/view',
                component : () => import('../components/airtime/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/airtime/:id/timeline',
                component : () => import('../components/airtime/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },


    // Broadcast

    {
        path : '/admin/broadcast',
        component : () => import('../components/broadcast/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/broadcast/create',
        component : () => import('../components/broadcast/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/broadcast/:id/view',
        component : () => import('../components/broadcast/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/broadcast/:id/view',
                component : () => import('../components/broadcast/view'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },


    // Telone

    {
        path : '/admin/telone',
        component : () => import('../components/telone/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/telone/recharge',
        component : () => import('../components/telone/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/telone/bill',
        component : () => import('../components/telone/bill'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/telone/bundle',
        component : () => import('../components/telone/bundle'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/telone/:id/view',
        component : () => import('../components/telone/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/telone/:id/view',
                component : () => import('../components/telone/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/telone/:id/timeline',
                component : () => import('../components/telone/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Bundles

    {
        path : '/admin/bundle',
        component : () => import('../components/bundle/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/bundle/create',
        component : () => import('../components/bundle/create'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/bundle-smart/create',
        component : () => import('../components/bundle/create-smart'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/netone/create',
        component : () => import('../components/bundle/create-netone'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/bundles/:id/view',
        component : () => import('../components/bundle/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/bundles/:id/view',
                component : () => import('../components/bundle/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/bundles/:id/timeline',
                component : () => import('../components/bundle/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Ecocash

    {
        path : '/admin/ecocash',
        component : () => import('../components/ecocash/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/ecocash/:id/view',
        component : () => import('../components/ecocash/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/ecocash/:id/view',
                component : () => import('../components/ecocash/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/ecocash/:id/timeline',
                component : () => import('../components/ecocash/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Stripe

    {
        path : '/admin/stripe',
        component : () => import('../components/stripe/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/stripe/:id/view',
        component : () => import('../components/stripe/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/stripe/:id/view',
                component : () => import('../components/stripe/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/stripe/:id/timeline',
                component : () => import('../components/stripe/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },


    // wallet

    {
        path : '/admin/wallet',
        component : () => import('../components/wallet/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/wallet/:id/view',
        component : () => import('../components/wallet/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/wallet/:id/view',
                component : () => import('../components/wallet/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/wallet/:id/timeline',
                component : () => import('../components/wallet/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },


    // Manual

    {
        path : '/admin/manual',
        component : () => import('../components/manual/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/manual/:id/view',
        component : () => import('../components/manual/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/manual/:id/view',
                component : () => import('../components/manual/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/manual/:id/timeline',
                component : () => import('../components/manual/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Payouts

    {
        path : '/admin/payouts',
        component : () => import('../components/payouts/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/payouts/:id/view',
        component : () => import('../components/payouts/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/payouts/:id/view',
                component : () => import('../components/payouts/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/payouts/:id/timeline',
                component : () => import('../components/payouts/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },
    // Agents

    {
        path : '/admin/agents/create',
        component : () => import('../components/agents/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/agents',
        component : () => import('../components/agents/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/agents/:id/view',
        component : () => import('../components/agents/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/agents/:id/view',
                component : () => import('../components/agents/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/agents/:id/edit',
                component : () => import('../components/agents/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/agents/:id/transactions',
                component : () => import('../components/agents/transactions'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    {
        path : '/admin/settings',
        component : () => import('../components/settings/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/settings',
                component : () => import('../components/settings/profile'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/password',
                component : () => import('../components/settings/password'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Roles

    {
        path : '/admin/roles/create',
        component : () => import('../components/roles/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/roles',
        component : () => import('../components/roles/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/roles/:id/view',
        component : () => import('../components/roles/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/roles/:id/view',
                component : () => import('../components/roles/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/roles/:id/edit',
                component : () => import('../components/roles/edit'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // SMS Management

    {
        path : '/admin/sms',
        component : () => import('../components/sms/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/sms/:id/view',
        component : () => import('../components/sms/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/sms/:id/view',
                component : () => import('../components/sms/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/sms/:id/timeline',
                component : () => import('../components/sms/timeline'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // Configuration

    {
        path : '/admin/configuration',
        component : () => import('../components/configuration/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/configuration/:id/view',
        component : () => import('../components/configuration/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/configuration/:id/view',
                component : () => import('../components/configuration/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/configuration/:id/edit',
                component : () => import('../components/configuration/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/configuration/:id/timeline',
                component : () => import('../components/configuration/timeline'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // Econet Bundles

    {
        path : '/admin/configuration/bundles',
        component : () => import('../components/econet/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/configuration/bundles/create',
        component : () => import('../components/econet/create.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/configuration/bundles/:id/view',
        component : () => import('../components/econet/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/configuration/bundles/:id/view',
                component : () => import('../components/econet/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/configuration/bundles/:id/edit',
                component : () => import('../components/econet/edit'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },


    // Econet Smart Bundles

    {
        path : '/admin/configuration/bundles-smart',
        component : () => import('../components/econet-smart/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/configuration/bundles-smart/create',
        component : () => import('../components/econet-smart/create.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/configuration/bundles-smart/:id/view',
        component : () => import('../components/econet-smart/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/configuration/bundles-smart/:id/view',
                component : () => import('../components/econet-smart/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/configuration/bundles-smart/:id/edit',
                component : () => import('../components/econet-smart/edit'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // Net One

    {
        path : '/admin/configuration/netone',
        component : () => import('../components/netone/index'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path : '/admin/configuration/netone/create',
        component : () => import('../components/netone//create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/configuration/netone/:id/view',
        component : () => import('../components/netone/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/configuration/netone/:id/view',
                component : () => import('../components/netone/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/configuration/netone/:id/edit',
                component : () => import('../components/netone/edit'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // Bank

    {
        path : '/admin/bank',
        component : () => import('../components/bank/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/bank/:id/view',
        component : () => import('../components/bank/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/bank/:id/view',
                component : () => import('../components/bank/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/bank/:id/timeline',
                component : () => import('../components/bank/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Messages

    {
        path : '/admin/bot/messages/template',
        component : () => import('../components/messages/template'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/bot/messages',
        component : () => import('../components/messages/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/bot/messages/:id/view',
        component : () => import('../components/messages/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/bot/messages/:id/view',
                component : () => import('../components/messages/view'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Cash

    {
        path : '/admin/cash',
        component : () => import('../components/cash/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/cash/:id/view',
        component : () => import('../components/cash/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/cash/:id/view',
                component : () => import('../components/cash/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/cash/:id/timeline',
                component : () => import('../components/cash/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Contacts


    {
        path : '/admin/bot/contacts',
        component : () => import('../components/contacts/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/bot/contacts/:id/view',
        component : () => import('../components/contacts/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/bot/contacts/:id/view',
                component : () => import('../components/contacts/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/bot/contacts/:id/tickets',
                component : () => import('../components/contacts/tickets'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Chat

    {
        path : '/admin/bot/chats',
        component : () => import('../components/chats/index'),
        meta : {
            requiresAuth : true
        },
    },

    {
        path : '/admin/bot/chats/support',
        component : () => import('../components/chats/support'),
        meta : {
            requiresAuth : true
        },
    },


    // Ticket

    {
        path : '/admin/bot/tickets',
        component : () => import('../components/ticket/index'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path : '/admin/bot/tickets/auto',
        component : () => import('../components/ticket/auto'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path : '/admin/bot/tickets/tool',
        component : () => import('../components/ticket/tool'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path : '/admin/bot/tickets/create',
        component : () => import('../components/ticket/create'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path : '/admin/bot/tickets/:id/view',
        component : () => import('../components/ticket/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/bot/tickets/:id/view',
                component : () => import('../components/ticket/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/bot/tickets/:id/edit',
                component : () => import('../components/ticket/edit'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // Business

    {
        path : '/admin/business',
        component : () => import('../components/business/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/business/:id/view',
        component : () => import('../components/business/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/business/:id/view',
                component : () => import('../components/business/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/business/:id/transactions',
                component : () => import('../components/business/transactions'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/business/:id/accept',
                component : () => import('../components/business/accept'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/business/:id/decline',
                component : () => import('../components/business/decline'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },



    // Corporates

    {
        path : '/admin/corporates/create',
        component : () => import('../components/corporates/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/corporates',
        component : () => import('../components/corporates/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/corporates/:id/view',
        component : () => import('../components/corporates/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/corporates/:id/view',
                component : () => import('../components/corporates/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/corporates/:id/edit',
                component : () => import('../components/corporates/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/corporates/:id/wallets',
                component : () => import('../components/corporates/wallets.vue'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },


    // Wallets

    {
        path : '/admin/wallets/create',
        component : () => import('../components/wallets/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/wallets',
        component : () => import('../components/wallets/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/wallets/:id/view',
        component : () => import('../components/wallets/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/wallets/:id/view',
                component : () => import('../components/wallets/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/wallets/:id/edit',
                component : () => import('../components/wallets/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/wallets/:id/transaction',
                component : () => import('../components/wallets/transact'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/wallets/:id/statement',
                component : () => import('../components/wallets/statement'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },


    // Users

    {
        path : '/admin/users/create',
        component : () => import('../components/users/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/users',
        component : () => import('../components/users/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/users/:id/view',
        component : () => import('../components/users/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/users/:id/view',
                component : () => import('../components/users/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/users/:id/edit',
                component : () => import('../components/users/edit'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },


    // Rates

    {
        path : '/admin/rates/create',
        component : () => import('../components/rates/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/rates',
        component : () => import('../components/rates/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/rates/:id/view',
        component : () => import('../components/rates/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/rates/:id/view',
                component : () => import('../components/rates/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/rates/:id/edit',
                component : () => import('../components/rates/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/rates/:id/timeline',
                component : () => import('../components/rates/timeline'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // ZESA Tariffs

    {
        path: '/admin/zesa-tariffs',
        component: () => import('../components/zesa-tariffs/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/zesa-tariffs/:id/view',
        component: () => import('../components/zesa-tariffs/open'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/admin/zesa-tariffs/:id/view',
                component: () => import('../components/zesa-tariffs/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/admin/zesa-tariffs/:id/edit',
                component: () => import('../components/zesa-tariffs/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/admin/zesa-tariffs/:id/timeline',
                component: () => import('../components/zesa-tariffs/timeline'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Traffic Offenders

    {
        path: '/admin/traffic-offenders',
        component: () => import('../components/traffic-offenders/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/traffic-offenders/create',
        component: () => import('../components/traffic-offenders/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/traffic-offenders/:id/view',
        component: () => import('../components/traffic-offenders/open'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/admin/traffic-offenders/:id/view',
                component: () => import('../components/traffic-offenders/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/admin/traffic-offenders/:id/edit',
                component: () => import('../components/traffic-offenders/edit'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // Rates

    {
        path : '/admin/challenge',
        component : () => import('../components/challenge/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/challenge/:id/view',
        component : () => import('../components/challenge/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/challenge/:id/view',
                component : () => import('../components/challenge/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/challenge/:id/timeline',
                component : () => import('../components/challenge/timeline'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Rates

    {
        path : '/admin/token',
        component : () => import('../components/tokens/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/token/:id/view',
        component : () => import('../components/tokens/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/token/:id/view',
                component : () => import('../components/tokens/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/token/:id/timeline',
                component : () => import('../components/tokens/timeline'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Billers
    {
        path : '/admin/billers/create',
        component : () => import('../components/billers/create.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/billers',
        component : () => import('../components/billers/index.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/billers/:id/view',
        component : () => import('../components/billers/open.vue'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/billers/:id/view',
                component : () => import('../components/billers/view.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/billers/:id/edit',
                component : () => import('../components/billers/edit.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/billers/:id/bills',
                component : () => import('../components/billers/bills.vue'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    // Bills
    {
        path : '/admin/billers/bills/create',
        component : () => import('../components/billers/bills/create.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/billers/bills',
        component : () => import('../components/billers/bills/index.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/billers/bills/:id/view',
        component : () => import('../components/billers/bills/open.vue'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/billers/bills/:id/view',
                component : () => import('../components/billers/bills/view.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/billers/bills/:id/edit',
                component : () => import('../components/billers/bills/edit.vue'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },

    // Categories
    {
        path : '/admin/billers/category/create',
        component : () => import('../components/billers/category/create.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/billers/category',
        component : () => import('../components/billers/category/index.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/billers/category/:id/view',
        component : () => import('../components/billers/category/open.vue'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/billers/category/:id/view',
                component : () => import('../components/billers/category/view.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/billers/category/:id/edit',
                component : () => import('../components/billers/category/edit.vue'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    // Biller-Exemption
    {
        path : '/admin/biller-exemption/create',
        component : () => import('../components/billers/biller-exemption/create.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/biller-exemption',
        component : () => import('../components/billers/biller-exemption/index.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/biller-exemption/:id/view',
        component : () => import('../components/billers/biller-exemption/open.vue'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/biller-exemption/:id/view',
                component : () => import('../components/billers/biller-exemption/view.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/biller-exemption/:id/edit',
                component : () => import('../components/billers/biller-exemption/edit.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/biller-exemption/:id/timeline',
                component : () => import('../components/billers/biller-exemption/timeline'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    //Billers End

    // Events
    {
        path : '/admin/tickets/events/create',
        component : () => import('../components/tickets-events/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/events',
        component : () => import('../components/tickets-events/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/events/:id/view',
        component : () => import('../components/tickets-events/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/tickets/events/:id/view',
                component : () => import('../components/tickets-events/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/tickets/events/:id/edit',
                component : () => import('../components/tickets-events/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/tickets/events/:id/types',
                component : () => import('../components/tickets-events/types'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Types
    {
        path : '/admin/tickets/types/create',
        component : () => import('../components/ticket-types/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/types',
        component : () => import('../components/ticket-types/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/types/:id/view',
        component : () => import('../components/ticket-types/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/tickets/types/:id/view',
                component : () => import('../components/ticket-types/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/tickets/types/:id/edit',
                component : () => import('../components/ticket-types/edit'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/tickets/types/:id/inventory',
                component : () => import('../components/ticket-types/inventory'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Categories
    {
        path : '/admin/tickets/category/create',
        component : () => import('../components/ticket-category/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/category',
        component : () => import('../components/ticket-category/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/category/:id/view',
        component : () => import('../components/ticket-category/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/tickets/category/:id/view',
                component : () => import('../components/ticket-category/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/tickets/category/:id/edit',
                component : () => import('../components/ticket-category/edit'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Inventory
    {
        path : '/admin/tickets/inventory/create',
        component : () => import('../components/ticket-inventory/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/inventory',
        component : () => import('../components/ticket-inventory/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/tickets/inventory/:id/view',
        component : () => import('../components/ticket-inventory/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/tickets/inventory/:id/view',
                component : () => import('../components/ticket-inventory/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/tickets/inventory/:id/edit',
                component : () => import('../components/ticket-inventory/edit'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Gift Cards

    {
        path : '/admin/gift-cards/create',
        component : () => import('../components/gift-cards/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-cards',
        component : () => import('../components/gift-cards/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-cards-terms',
        component : () => import('../app/admin/views/gift-cards.terms.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-cards/:id/view',
        component : () => import('../components/gift-cards/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/gift-cards/:id/view',
                component : () => import('../components/gift-cards/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/gift-cards/:id/edit',
                component : () => import('../components/gift-cards/edit'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Gift Category

    {
        path : '/admin/gift-category/create',
        component : () => import('../components/gift-category/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-category',
        component : () => import('../components/gift-category/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-category/:id/view',
        component : () => import('../components/gift-category/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/gift-category/:id/view',
                component : () => import('../components/gift-category/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/gift-category/:id/edit',
                component : () => import('../components/gift-category/edit'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Gift Cards Types
    {
        path : '/admin/gift-cards-types/create',
        component : () => import('../components/gift-cards-types/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-cards-types',
        component : () => import('../components/gift-cards-types/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-cards-types/:id/view',
        component : () => import('../components/gift-cards-types/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/gift-cards-types/:id/view',
                component : () => import('../components/gift-cards-types/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/gift-cards-types/:id/edit',
                component : () => import('../components/gift-cards-types/edit'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Gift Cards Inventory
    {
        path : '/admin/gift-cards-inventory/create',
        component : () => import('../components/gift-cards-inventory/create'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-cards-inventory',
        component : () => import('../components/gift-cards-inventory/index'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/admin/gift-cards-inventory/:id/view',
        component : () => import('../components/gift-cards-inventory/open'),
        meta: {
            requiresAuth: true
        },
        children : [
            {
                path : '/admin/gift-cards-inventory/:id/view',
                component : () => import('../components/gift-cards-inventory/view'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path : '/admin/gift-cards-inventory/:id/edit',
                component : () => import('../components/gift-cards-inventory/edit'),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },

    // Delivery

    {
        path : '/admin/delivery',
        component : () => import('../components/delivery/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/delivery/:id/view',
        component : () => import('../components/delivery/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/delivery/:id/view',
                component : () => import('../components/delivery/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/delivery/:id/timeline',
                component : () => import('../components/delivery/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },


    // Zinara

    {
        path : '/admin/zinara',
        component : () => import('../components/zinara/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/zinara/create',
        component : () => import('../components/zinara/create'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/zinara/:id/view',
        component : () => import('../components/zinara/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/zinara/:id/view',
                component : () => import('../components/zinara/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/zinara/:id/timeline',
                component : () => import('../components/zinara/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },
    // Wallet Deposit

    {
        path : '/admin/wallet-deposit',
        component : () => import('../components/wallet-deposit/index'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/wallet-deposit/create',
        component : () => import('../components/wallet-deposit/create'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/wallet-deposit/:id/view',
        component : () => import('../components/wallet-deposit/open'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/wallet-deposit/:id/view',
                component : () => import('../components/wallet-deposit/view'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/wallet-deposit/:id/timeline',
                component : () => import('../components/wallet-deposit/timeline'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },

    // Business Approvals

    {
        path : '/admin/business-approvals/billers',
        component : () => import('../components/business-approvals/billers/index.vue'),
        meta : {
            requiresAuth : true
        }
    },
    {
        path : '/admin/business-approvals/billers/:id/view',
        component : () => import('../components/business-approvals/billers/open.vue'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/business-approvals/billers/:id/view',
                component : () => import('../components/business-approvals/billers/view.vue'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/business-approvals/billers/:id/timeline',
                component : () => import('../components/business-approvals/billers/timeline.vue'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },
    {
        path : '/admin/business-approvals/events',
        component : () => import('../components/business-approvals/events/index.vue'),
        meta : {
            requiresAuth : true
        }
    },

    {
        path : '/admin/business-approvals/events/:id/view',
        component : () => import('../components/business-approvals/events/open.vue'),
        meta : {
            requiresAuth : true
        },
        children : [
            {
                path : '/admin/business-approvals/events/:id/view',
                component : () => import('../components/business-approvals/events/view.vue'),
                meta : {
                    requiresAuth : true
                }
            },
            {
                path : '/admin/business-approvals/events/:id/timeline',
                component : () => import('../components/business-approvals/events/timeline.vue'),
                meta : {
                    requiresAuth : true
                }
            },
        ]
    },






];


export default routes;
